export const GET_BOM_VALIDATION = '/components/:validationId'
export const DELETE_BOM_VALIDATION = '/component/:validationId'
export const BOM_VALIDATION_EXPORT = '/export/bom-validation/:validationId'
export const BOM_VALIDATION_TRIGGER = '/bom-validation/:encodedBusinessName'
export const BOM_VALIDATIONS = '/components'
export const INVALID_CHOICES_VALIDATION_EXPORT = '/export/invalid-choices/:validationId'
export const UNUSED_KV_EXPLANATION = '/:pmEncodedBusinessName/:componentId/:unusedKVId'
export const BOM_VALIDATION_EXPLANATION = '/bom-validation/explanation'
export const BOM_VALIDATION_ELEMENTS = ':validationId/elements'
